import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaClock, FaTag } from 'react-icons/fa';
import { specialOffers } from '../data/hotelData';
import Newsletter from '../components/Newsletter/Newsletter';
import './Offers.css';

export default function Offers() {
  return (
    <main>
      <div className="page-banner">
        <div className="page-banner-content">
          <span className="section-badge">Save More</span>
          <h1>Special Offers</h1>
          <p>Exclusive packages crafted for unforgettable stays</p>
        </div>
      </div>

      <section className="section offers-page">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Limited Time</span>
            <h2 className="section-title">Exclusive Packages</h2>
            <div className="gold-line" />
            <p className="section-subtitle">
              Book direct and enjoy our best rates with complimentary perks — only available on our website.
            </p>
          </div>

          <div className="offers-grid">
            {specialOffers.map((offer, i) => (
              <motion.div
                key={offer.id}
                className="offer-card"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.15 }}
              >
                <div className="offer-card-image">
                  <img src={offer.image} alt={offer.title} />
                  <div className="offer-discount-badge">
                    <FaTag />
                    <strong>{offer.discount}</strong>
                  </div>
                  {offer.badge && <span className="offer-badge">{offer.badge}</span>}
                </div>

                <div className="offer-card-body">
                  <span className="offer-subtitle">{offer.subtitle}</span>
                  <h3 className="offer-title">{offer.title}</h3>
                  <p className="offer-desc">{offer.description}</p>

                  <div className="offer-includes">
                    <h4>Package Includes:</h4>
                    <ul>
                      {offer.includes.map(item => (
                        <li key={item}><FaCheckCircle /> {item}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="offer-footer">
                    <div className="offer-pricing">
                      <span className="offer-original">${offer.originalPrice}</span>
                      <strong className="offer-price">${offer.price}</strong>
                      <span className="offer-per">/night</span>
                    </div>
                    <div className="offer-valid">
                      <FaClock />
                      <span>Valid until {offer.validUntil}</span>
                    </div>
                  </div>

                  <Link to="/booking" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
                    Book This Package
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Newsletter />
    </main>
  );
}
